export const LOCALE_FILES = {
  'en': 'en.json',
  'es': 'es.json',
  'es-mx': 'es_MX.json',
  'pt': 'pt_PT.json',
  'pt-br': 'pt_BR.json',
  'de': 'de.json',
  'fr': 'fr_FR.json',
  'it': 'it_IT.json',
} as const;

export type LocaleCode = keyof typeof LOCALE_FILES;

export const LOCALE_CODES = Object.keys(LOCALE_FILES) as LocaleCode[];

export const KEYS_TEST_LOCALE = 'keys-test';

export type RoutableLocale = LocaleCode | typeof KEYS_TEST_LOCALE;

export const ROUTABLE_LOCALES: RoutableLocale[] = [...LOCALE_CODES, KEYS_TEST_LOCALE];
